export default {
  '新增计划':'Add Plan',
  '计划名称':'Plan Name',
  '请输入计划名称':'Enter plan name',
  '内容及范围':'Content & Scope',
  '测试类型':'Test Type',
  '体测模拟':'Fitness Test Simulation',
  '体考模拟':'Exam Simulation',
  '测试标准':'Testing Standard',
  '请选择测试标准':'Select testing standard',
  '测试项目':'Test Items',
  '项目与分值':'Items & Scores',
  '项目满分':'Full Score per Item',
  '总满分':'Total Full Score',
  '必考':'Mandatory',
  '一类选考项目':'Category 1 Electives',
  '二类选考项目':'Category 2 Electives',
  '不限':'Unrestricted',
  '仅限男':'Male Only',
  '仅限女':'Female Only',
  '请输入分值':'Enter score value',
  '计算方式':'Calculation Method',
  '请输入总满分':'Enter total full score',
  '请填写计算方式':'Enter calculation method',
  '精度':'Precision',
  '取值方式':'Rounding Method',
  '整数':'Integer',
  '小数点后一位':'1 decimal place',
  '小数点后两位':'2 decimal places',
  '小数点后三位':'3 decimal places',
  '四舍五入':'Round',
  '向上取整':'Round Up',
  '向下取整':'Round Down',
  '最终总分数':'Final Total Score',
  '是否报名':'Registration Required',
  '是':'Yes',
  '否':'No',
  '测试报告':'Test Report',
  '线上支付':'Online Payment',
  '请输入':'Enter',
  '元':'CNY',
  '线下支付':'Offline Payment',
  '免费':'Free',
  '测试范围':'Testing Scope',
  '请选择测试范围':'Select testing scope',
  '请填写计划名称':'Enter plan name',
  '请选择测试时间':'Select testing period',
  '请选择测试类型':'Select test type',
  '请选择测试项目':'Select test items',
  '请填写测试项目分值':'Enter item scores',
  '请输入项目分值':'Enter item score',
  '请输入项目计算方式':'Enter item calculation method',
  '一类选考项目需填写相同分值':'Category 1 electives require identical scores',
  '二类选考项目需填写相同分值':'Category 2 electives require identical scores',
  '请填写最终总分数计算方式':'Enter final score calculation method',
  '请输入有效的计算方式':'Enter valid calculation method',
  '请选择是否报名':'Select registration requirement',
  '请选择测试报告支付方式':'Select report payment method',
  '金额至少为':'Minimum amount: 0.01',
  '请选择测试班级':'Select testing classes',
  '是否取消':'Confirm cancellation',
  '取消后，页面数据不做保存':'Unsaved data will be lost',
  '查看计划':'View Plan',
  '详情':'Details',
  '报名':'Register',
  '已报名':'Registered',
  '未报名':'Unregistered',
  '明细':'Breakdown',
  '报名模板':'Registration Template',
  '批量成绩导入失败列表':'Bulk Import Failure List',
  '姓名与学籍号与失败原因':'Name, ID, Error Reason',
  '组织测试列表':'Testing Organization List',
  '确认要提前结束该计划':'Confirm early termination of plan:',
  '计划结束后不再支持学生测试':'Testing unavailable after plan ends',
  '确认要删除该计划':'Confirm plan deletion:',
  '删除后将无法查看本计划数据':'Data will become inaccessible',
  '参与机构':'Participating Organizations',
  '测试名称':'Test Name',
  '测试周期':'Testing Period',
  '成绩导入':'Import Results',
  '成绩导出':'Export Results',
  '测试记录导出':'Export Test Records',
  '测试记录':'Test Records',
  "删除计划成功":'Plan deleted',
  "提前结束测试成功":'Test terminated early',
  "测试成绩导出":'Export Test Results',
  "全校":'School-wide',
  "部分":'Partial',
  "（标准已删除）":'(Standard Deleted)',
  "（标准已停用）":'(Standard Disabled)',
  "测试计划已结束":'Testing plan has ended and cannot be edited',
  "数据来源":'Data Source',
  "是否自助测试":'​Self-Service Testing​​',
  "是":'Yes',
  "否":'No',
  "测试方式":'Testing Method​',
  "校内组织":'Campus Organizations​​',
  "自助测试":'​​Self-Service Testing​',
  "运动详情":'Fitness Details​',
  "运动视频片段":'Fitness Video Clips',
  "运动过程图片":'​Workout Progress Photos​',
  "录入":'Data Entry​',
  '计划明细导入完成':'​Plan details import completed',
  '计划明细模板':'Plan details template​',
  '学生是否预约':'​​Student Reservation Status​',
  '可预约日期':' ​Available Dates​',
  '预约配置':'Reservation Settings​',
  '去设置':'Go to Settings​',
  '去修改':'​​Modify​',
  '跑步类项目可预约时段':'​​Running Event Time Slots​',
  '跑步类项目':'​​Running Event',
  '非跑步类项目':'​​Non-Running Event',
  '预约人数':'​​Reservation Count​',
  '非跑步类项目可预约时段':'​​Non-Running Event Time Slots​',
  '跑步类项目，如50':'Running events (e.g., 50m/800m/1000m run)​',
  '非跑步类项目，如肺活量、仰卧起坐等':'Non-running events (e.g., lung capacity、sit-ups)​',
  '预约配置不可为空':'Reservation settings cannot be empty​',
  '可预约时段不可为空':'Available time slots cannot be empty​',
  '预约时段':'Available time slots',
  '预约人数不可为空':'Reservation count cannot be empty​',
  '设置预约信息':'Set Reservation Information​',
  '预约数据导出':'Export Reservation Data​',
  '预约数据':'Reservation Data​',
  '项目分类':'​Exercise Categories​​',
  '该时段已有学生预约，删除将清空已有预约数据':'This time slot already has student reservations. Deletion will clear all existing booking data.​',
  '已有学生预约，切换预约模式清空已有预约数据':'Existing student reservations will be cleared when switching reservation modes',
  '作废':'Void​',
  '确定要作废此记录吗':'Are you sure you want to void this record',
  '请修改测试结果':'Please modify the test results​',
  '请填写结果':'Please enter the results​',
  '结果':'Results',
  '导出学生名单':'Export Student List​',
  '考生姓名':'Examinee Name​​',
  '预约详情':'Reservation Details​',
  '预约方式':'Reservation Method​',
  '重复':'Repeat​',
  '自定义':'​​Customize​',
  '请选择重复天数':'Please select the number of days to repeat​',
  '选择日期':'Select Date',
  '新增日期':'Add Date',
  '请选择测试时间和可预约日期':'Please select the test time and available dates',
  '可预约时段不可重复':'Available time slots cannot be duplicated',
  '存在重复可预约时段，请修改':'Duplicate bookable time slots detected. Please modify.',
  '预约学生名单':'Student Reservation List',
  '最优成绩导入':'Personal Best Records Import',
}